import { Component, OnInit } from "@angular/core";
import {
  BaseUpdateComponent,
  BaseDataService,
  ModalService,
  QueryParameter,
  NotificationService,
} from "yt-ng-framework";
import { AngazovanjeRo } from "./angazovanje-ro";
import { ActivatedRoute } from "@angular/router";
// import { NotificationsService } from "angular2-notifications";
import { Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ModelDataService } from "yt-ng-framework";
import { AnexRo } from "./anex-ro";
import { AngazovanjeRoValidators } from "../_validators/angazovanje-ro-validators";
import { RadnoVreme } from "../radno-vreme/radno-vreme";
import { UgovorRo } from "./ugovor-ro";
// import { ToastrService } from "ngx-toastr";

@Component({
  selector: "yt-angazovanje-ro-anex-update",
  templateUrl: "./angazovanje-ro-anex-update.component.html",
})
export class AngazovanjeRoAnexUpdateComponent
  extends BaseUpdateComponent<AnexRo>
  implements OnInit
{
  editMode = false;
  RadnoVremeItems: RadnoVreme;
  angazovanjeRoValidators = new AngazovanjeRoValidators();
  Ugovor: any;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modelDataService: ModelDataService,
    protected modalService: ModalService
  ) {
    super(
      activatedRoute,
      baseDataService,
      toastrService,
      translateService
    );
  }

  ngOnInit() {
    super.ngOnInit();

    this.baseFormGroup.setValidators([
      this.angazovanjeRoValidators.valRadnoVremePrcAng(this),
      this.angazovanjeRoValidators.valCenaRada(this),
      this.angazovanjeRoValidators.valAneksUOdnosuNaUgovor(this),
    ]);

    this.IDProcessed.subscribe((value) => {
      if (value) {
        if (this.baseFormGroup.get("ID").value != null) {
          this.editMode = true;
        }
        if (!this.editMode) {
          // let osobaId=this.Parameters.find(x => x["Name"] =="OsobaID")["Value"]
          let tataId = this.Parameters.find((x) => x["Name"] == "TataID")[
            "Value"
          ];
          // this.baseFormGroup.patchValue({OsobaID: osobaId});
          // this.baseFormGroup.patchValue({TataID: tataId});
          // this.baseFormGroup.controls["OsobaID"].disable();
          // this.baseFormGroup.controls["TataID"].disable();

          // let qpUgovorID = new QueryParameter("ID", this.baseFormGroup.get("TataID").value);
          let qpUgovorID = new QueryParameter("ID", tataId);

          this.baseDataService
            .Get("AngazovanjeRo", "Get", [qpUgovorID], UgovorRo)
            .subscribe((data) => {
              this.Ugovor = data;
              this.baseFormGroup.patchValue({ OsobaID: this.Ugovor.OsobaID });
              // this.baseFormGroup.patchValue({TataID: this.Ugovor.TataId});
              this.baseFormGroup.patchValue({ TataID: this.Ugovor.ID });
              this.baseFormGroup.controls["OsobaID"].disable();
              this.baseFormGroup.controls["TataID"].disable();

              this.baseFormGroup.patchValue({
                RadnoVremeID: this.Ugovor.RadnoVremeID,
              });
              this.baseFormGroup.patchValue({
                MestoRadaID: this.Ugovor.MestoRadaID,
              });
              this.baseFormGroup.patchValue({
                RadnoMestoID: this.Ugovor.RadnoMestoID,
              });
              this.baseFormGroup.patchValue({
                StatusRoID: this.Ugovor.StatusRoID,
              });
              this.baseFormGroup.patchValue({
                SistRadnihMestaID: this.Ugovor.SistRadnihMestaID,
              });
              this.baseFormGroup.patchValue({ ValutaID: this.Ugovor.ValutaID });
              this.baseFormGroup.patchValue({
                ObjekatID: this.Ugovor.ObjekatID,
              });
              this.baseFormGroup.patchValue({
                BeneficiraniID: this.Ugovor.BeneficiraniID,
              });
              this.baseFormGroup.patchValue({
                OrgJedRadaID: this.Ugovor.OrgJedRadaID,
              });
              this.baseFormGroup.patchValue({ OdDatuma: this.Ugovor.OdDatuma });
              this.baseFormGroup.patchValue({ DoDatuma: this.Ugovor.DoDatuma });
              this.baseFormGroup.patchValue({
                KoefZarade: this.Ugovor.KoefZarade,
              });
              this.baseFormGroup.patchValue({
                NetoZarada: this.Ugovor.NetoZarada,
              });
              this.baseFormGroup.patchValue({
                BrutoZarada: this.Ugovor.BrutoZarada,
              });
              this.baseFormGroup.patchValue({ PrcAng: this.Ugovor.PrcAng });
              this.baseFormGroup.patchValue({
                NedFondSati: this.Ugovor.NedFondSati,
              });
              this.baseFormGroup.patchValue({
                BrutoCenaSata: this.Ugovor.BrutoCenaSata,
              });
              this.baseFormGroup.patchValue({
                NetoCenaSata: this.Ugovor.NetoCenaSata,
              });
              this.baseFormGroup.patchValue({
                BrojSmena: this.Ugovor.BrojSmena,
              });
              this.baseFormGroup.patchValue({
                BrojPoslodavaca: this.Ugovor.BrojPoslodavaca,
              });
              this.baseFormGroup.patchValue({ Ugovoren: this.Ugovor.Ugovoren });
            });

          // Ovde treba da se popune i ostala polja aneksa sadržajem iz ugovora i da se omogući korisniku da izmeni šta treba
        }
      }
    });
  }

  onPodvrstaDokumentaStavkaSelected(item) {
    if (item != null) {
      // this.RaskidUgovora=item["PodvrstaDokumentaGn"]=="resenje";
      // this.Ugovor=item["PodvrstaDokumentaGn"]=="ug";
      // this.AneksUgovora=item["PodvrstaDokumentaGn"]=="anex_ug";
      this.getBrojDokumenta();
    }
  }

  onDatumChange(value) {
    if (value != null) {
      this.getBrojDokumenta();
    }
  }

  getBrojDokumenta() {
    let podvrstaid = this.baseFormGroup.get("PodvrstaDokumentaStavkaID").value;
    let datum = this.baseFormGroup.get("Datum").value;
    if (this.Item.ID == -1 && podvrstaid && datum)
      this.baseDataService
        .GetData("AngazovanjeRo", "KreirajBrojDokumenta", {
          PodVrstaDokumentaStavkaID: podvrstaid,
          Datum: datum,
        })
        .subscribe((data) => {
          this.baseFormGroup.patchValue({ Broj: data });
          this.baseFormGroup.get("Broj").updateValueAndValidity();
        });
  }

  RadnoVremeGetItems(items) {
    this.RadnoVremeItems = items;
  }
}
